export default {
  computed: {
    viewEditMode() {
      return this.$store.getters.getViewEditMode;
    },
  },

  methods: {
    setViewFilters(filters) {
      this.$store.dispatch('setViewFilters', filters);
      this.$store
        .dispatch('fetchNewViewResults', {
          card_filters: { ...filters },
          type: 'card',
        })
        .then(({ cards, count }) => {
          this.$store.dispatch('setViewResults', cards);
          this.$store.dispatch('currentViewTotalCount', count);
        });
    },

    setViewPills(pills) {
      this.$store.dispatch('setViewPills', pills);
    },

    setViewEditMode(isEditMode) {
      this.$store.dispatch('setViewEditMode', isEditMode);
    },
  },
};
